import React from 'react'
import { css, withTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { propFunc } from 'util/functions'
import { Avatar, Button, Icon, ValidatedInput } from 'shared/ui'
import { Form, TextArea } from 'util/ui'
import { join, email, url, required } from 'util/validation'
import withFormFields from 'shared/ui/Form/withFormFields'
import { Container, Header } from './shared'

const LabelWithIcon = styled('label')`
  &&&&& {
    display: flex;
    align-items: center;
  }
`

class EditingState extends React.Component {
  handleChange = (name, validate, e) => {
    const { onChange } = this.props
    onChange(name, e.target.value, validate)
  }

  makeValidatedFormField = ({
    as,
    name,
    label,
    iconName,
    placeholder,
    validate,
  }) => {
    const { formFields, formFieldsErrors, theme } = this.props
    return (
      <Form.Field
        css={css`
          &&&& {
            margin-bottom: ${theme.spacing['10']};
          }
        `}
      >
        <LabelWithIcon>
          {iconName && (
            <Icon
              className="grui mr-4"
              name={iconName}
              color="color.monochrome.mediumDark"
              size="xsmall"
            />
          )}
          {label}
        </LabelWithIcon>
        <ValidatedInput
          as={as}
          size="small"
          placeholder={placeholder}
          defaultValue={formFields[name]}
          errorMessage={formFieldsErrors[name]}
          onChange={propFunc(this.handleChange, name, validate)}
        />
      </Form.Field>
    )
  }

  handleCancel = () => {
    const { resetForm, closeForm } = this.props
    resetForm()
    closeForm()
  }

  handleSubmit = () => {
    this.props.submitForm()
  }

  handleEnter = e => {
    const key = e.charCode || e.keyCode
    if (key === 13) e.preventDefault()
    // if (key !== 13) return
    // if (
    //   e.currentTarget === this.submitRef ||
    //   e.currentTarget === this.resetRef
    // ) {
    //   this.handleSubmit()
    // }
    // e.preventDefault()
  }

  takeSubmitRef = node => {
    this.submitRef = node
  }

  takeResetRef = node => {
    this.resetRef = node
  }

  render() {
    const { customer, saving, formFieldErrors, theme } = this.props

    return (
      <Container>
        <Avatar
          actor={customer}
          size={48}
          initialsFontSize={16}
          initialsColor={theme.color.monochrome.white}
          initialsBackground={theme.color.primary.brand}
        />

        <Header>{customer.labelFull}</Header>

        <Form onKeyPress={this.handleEnter}>
          {this.makeValidatedFormField({
            label: 'Email address',
            name: 'email',
            placeholder: 'someone@example.com',
            validate: join([email, required]),
          })}

          {this.makeValidatedFormField({
            as: TextArea,
            label: 'Short bio',
            name: 'about',
            placeholder: 'Short paragraph about the person…',
          })}

          {this.makeValidatedFormField({
            label: 'Name',
            name: 'name',
            iconName: 'account-circle',
            placeholder: 'John Doe',
            validate: required,
          })}

          {this.makeValidatedFormField({
            label: 'Website',
            name: 'website_url',
            iconName: 'language',
            placeholder: 'https://example.com',
            validate: url,
          })}

          {this.makeValidatedFormField({
            label: 'Company',
            name: 'company_name',
            iconName: 'copyright',
            placeholder: 'Acme Inc.',
          })}

          {this.makeValidatedFormField({
            label: 'Phone',
            name: 'phone_number',
            iconName: 'phone',
            placeholder: '+1 555 123 456 7890',
          })}

          {this.makeValidatedFormField({
            label: 'Location',
            name: 'location',
            iconName: 'place',
            placeholder: 'Address…',
          })}

          <Button
            primary
            onClick={this.handleSubmit}
            disabled={saving || formFieldErrors}
            ref={this.takeSubmitRef}
          >
            Save
          </Button>
          <Button
            basic
            onClick={this.handleCancel}
            disabled={saving}
            className="grui ml-10"
            ref={this.takeResetRef}
          >
            Cancel
          </Button>
        </Form>
      </Container>
    )
  }
}

export default withTheme(withFormFields(EditingState))
